(function() {
  var __sections__ = {};
  (function() {
    for(var i = 0, s = document.getElementById('sections-script').getAttribute('data-sections').split(','); i < s.length; i++)
      __sections__[s[i]] = true;
    })();
    (function() {
  if (!__sections__["community-image-with-text-2"] && !Shopify.designMode) return;
  try {
    
  var acc = document.getElementsByClassName("accordion");
  var panels = document.getElementsByClassName("panel");
  var i;

  function closeAllAccordions() {
    for (i = 0; i < acc.length; i++) {
      acc[i].classList.remove("active");
      panels[i].classList.remove("active");
      panels[i].style.display = "none";
    }
  }

  for (i = 0; i < acc.length; i++) {
    acc[i].addEventListener("click", function() {
      var isActive = this.classList.contains("active");
      closeAllAccordions();
      if (!isActive) {
        this.classList.add("active");
        this.nextElementSibling.classList.add("active");
        this.nextElementSibling.style.display = "block";
      }
    });
  }

  } catch(e) { console.error(e); }
})();
})();
